<template>
    <div class="section-box">
        <el-row class="row-bg">
            <el-col :span="12" style="text-align: left;line-height: 36px;">
                <el-button size="mini" :class="form.authstatus ==40 ?'selected':''" @click="titleClick(40)">待面试</el-button>
                <el-button size="mini" style="margin-left: 25px;" :class="form.authstatus ==50 ?'selected':''" @click="titleClick(50)">面试通过</el-button>
                <el-button size="mini" style="margin-left: 25px;" :class="form.authstatus ==60 ?'selected':''" @click="titleClick(60)">面试未通过</el-button>
            </el-col>
            <el-col :span="12" style="text-align: right;">
                <el-button size="medium" type="primary" @click="accRecordPass(1,50)" v-if="form.authstatus == 40">面试通过</el-button>
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
            </el-col>
        </el-row>
        <!-- 列表 -->
        <el-table ref="tableData"
            :stripe="true"
            :data="tableData"
            style="width: 100%"
            height="666"
            border
            @selection-change="handleSelectionChange"
            v-loading="listLoading" 
            v-show="form.authstatus == 40"
            >
            <!-- eslint-disable  -->
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="证书名称">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.authname" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.authname || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="面试人员">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.userName" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.userName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="联系方式" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.phone" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.phone || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="申请时间">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.createTime"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.createtime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="操作" width="230">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="accRecordPass(1,50,scope.row.id)">面试通过</el-button>
                    <el-button type="danger" size="mini" @click="accRecordPass(2,60,scope.row.id)">面试未通过</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-table 
            ref="tableData"
            :stripe="true"
            :data="tableData"
            style="width: 100%"
            height="666"
            border
            v-loading="listLoading" 
            v-show="form.authstatus == 50 || form.authstatus == 60"
            >
            <!-- eslint-disable  -->
            <el-table-column label="证书名称">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.authname" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.authname || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="面试人员">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.userName" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.userName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="联系方式" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.phone" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.phone || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="申请时间">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.createTime"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.createtime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="处理时间" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.dealTime"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.dealtime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="处理人">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.dealpersonName" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.dealpersonName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="证书编号" v-if="form.authstatus == 50">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.certificateno" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.certificateno || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>
        <p style="margin-bottom: -42px;font-size: 14px;line-height: 32px;" v-if="form.authstatus == 40">已选中 {{num}} 条信息</p>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.pageNum"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import {
    accRecordList,          //国家认证-面试|原厂认证-考核列表
    authStatusModi,         //国家认证|原厂认证-面试通过|不通过
} from "@/service/examination";
import { 
  getStorageToken,
  getStorageUserRoleId
} from '@/utils/store'
  export default {
    data() {
        return {
            listLoading: false,
            form: {
                pageNum: 1,
                pageSize: 10,
                rational: true,

                authconfigid: '',       //认证id
                authname: '',           //认证名称
                authstatus: 40,         //状态 (1待支付,10,已报名,20.考试已通过,30 考试未通过,40.已预约,50.面试通过,60.面试未通过,0.已过期) ,
                certificateno: '',      //证书编号
                userName: '',           //报名人员|面试人员 （用户）
                userid: '',             //用户id
                phone: '',              //联系方式

                createTime: [],         //创建时间
                dealTime: [],           //处理时间
                dealpersonName: '',     //处理人
                dealpersonid: '',       //处理人id
            },
            searchData:{},
            oraginForm:{},
            total: 0,                       //总条数
            tableData:[],
            num: 0,                         //选中的数量
            selected_items:{},
        }
    },
    activated(){
        this.handleSearch()
    },
    created() {
        this.oraginForm = JSON.parse(JSON.stringify(this.form))
        this.tableData = [];
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        titleClick(type){
            this.form.authstatus = type;
            this.selected_items = {}
            this.num = 0
            this.handleSearch()
        },
        //渲染列表
        handleSearch() {
            this.searchData = Object.assign({}, this.form)
            this.handleCurrentChange(1)
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.form.pageNum = val
            this.searchData.pageNum = val
            this.GetCouponsList()
        },
        //翻页
        handleSizeChange(val) {
        if (this.listLoading) return
            this.form.pageNum = 1
            this.form.pageSize = val
            this.searchData.pageNum = 1
            this.searchData.pageSize = val
            this.GetCouponsList()
        },
        async GetCouponsList(){
            const _this = this;
            this.listLoading = true
            let data = JSON.parse(JSON.stringify(this.searchData))
            !data.authconfigid && delete data.authconfigid
            !data.authname && delete data.authname
            data.authstatus === '' && delete data.authstatus
            !data.certificateno && delete data.certificateno
            !data.userName && delete data.userName
            !data.userid && delete data.userid
            !data.phone && delete data.phone
            data.authtype = 1
            if (data.createTime instanceof Array && data.createTime.length) {
                data.createTimeBegin = data.createTime[0] + " 00:00:00";
                data.createTimeEnd = data.createTime[1] + " 23:59:59";
            }
            delete data.createTime;
            if (data.dealTime instanceof Array && data.dealTime.length) {
                data.dealTimeBegin = data.dealTime[0] + " 00:00:00";
                data.dealTimeEnd = data.dealTime[1] + " 23:59:59";
            }
            delete data.dealTime;
            !data.dealpersonName && delete data.dealpersonName
            !data.dealpersonid && delete data.dealpersonid
            let res = await accRecordList(data)
            this.listLoading = false
            if(res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
            }

           const old = JSON.parse(JSON.stringify(this.selected_items));
           this.selected_items = {};

            this.tableData = res.Data.datas;
            this.total = res.Data.total;
            this.num = Object.keys(old).length;
            this.$forceUpdate();
            if (Object.keys(old).length) {
                this.$nextTick(() => {
                    for (var idx1 in _this.tableData) {
                        const item1 = _this.tableData[idx1];
                        if (old[item1.id]) {
                            _this.$refs.tableData.toggleRowSelection(item1);
                        }
                    }
                    for (var key1 in old) {
                        const item2 = old[key1];
                        _this.selected_items[key1] = item2;
                    }
                    _this.num = Object.keys(_this.selected_items).length;
                    _this.$forceUpdate();
                });
            }
            _this.$nextTick(()=>{
                _this.$refs.tableData.doLayout()
            })
        },
        handleReset() {
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.handleSearch()

            this.selected_items = {};
            this.$forceUpdate();

        },
        // table选中
        handleSelectionChange(val) {
            for (var idx in this.tableData)
            {
                const item = this.tableData[idx];
                if (this.selected_items[item.id]) delete this.selected_items[item.id];
            }

            for (var idxs in val)
            {
                const item2 = val[idxs];
                this.selected_items[item2.id] = item2;
            }
            this.num = Object.keys(this.selected_items).length;
        },
        // 点击面试通过
        accRecordPass(is,type,id){
            let data = {}
            data.ids = []
            data.authStatus = type
            data.nuserId = getStorageUserRoleId()
            data.nuserType = 1
            if(id) {
                data.ids = [id]
            }else{
                if(JSON.stringify(this.selected_items) == '{}') {
                    return this.$message.error('请选择面试通过人员')
                }
                for (var key in this.selected_items) {
                    const item = this.selected_items[key];
                    data.ids.push(item.id)
                }
            }
            let tips = '通过'
            if(is == 2) tips = '未通过'
            this.$confirm('确认'+ tips +'面试吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                authStatusModi(data).then(res=>{
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success('操作成功！')
                    this.GetCouponsList()
                })
            }).catch(() => {});
        },
    }
  }
</script>

<style lang="scss">
    .el-row {
        margin-bottom: 20px;
        &:last-child {
        margin-bottom: 0;
        }
    }
    .row-bg {
        padding: 10px 14px;
        background-color: #f9fafc;
    }
    .section-box {
        .selected {
            color: #409EFF;
            border-color: #c6e2ff;
            background-color: #ecf5ff;
        }
    }
</style>